import React from 'react';

const HomeBoldIcon = ({
  width = '16',
  height = '16',
  fill = '#1E1E1E',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill={fill}
    {...props}
  >
    <path
      d="M14.9963 8C14.9963 8.49219 14.6312 8.875 14.2174 8.875H13.4385L13.4628 13.25C13.4628 13.332 13.4628 13.4141 13.4628 13.4688V13.9062C13.4628 14.5352 13.0247 15 12.4892 15H12.0997C12.051 15 12.0267 15 12.0023 15C11.978 15 11.9293 15 11.905 15H10.5418C9.98199 15 9.56818 14.5352 9.56818 13.9062V11.5C9.56818 11.0352 9.20306 10.625 8.78926 10.625H7.23141C6.79326 10.625 6.45248 11.0352 6.45248 11.5V13.9062C6.45248 14.5352 6.01434 15 5.47882 15H4.1157C4.06702 15 4.04268 15 3.994 15C3.96965 15 3.94531 15 3.92097 15H3.53151C2.97166 15 2.55785 14.5352 2.55785 13.9062V10.8438C2.55785 10.8438 2.55785 10.8164 2.55785 10.7891V8.875H1.77893C1.34078 8.875 1 8.49219 1 8C1 7.75391 1.07302 7.53516 1.24341 7.34375L7.47482 1.21875C7.64521 1.02734 7.83994 1 8.01033 1C8.18072 1 8.37545 1.05469 8.5215 1.19141L14.7286 7.34375C14.9233 7.53516 15.0207 7.75391 14.9963 8Z"
      fill={fill}
    />
  </svg>
);

export default HomeBoldIcon;
